export default __webpack_public_path__ + "static/weather--sun-835ccd415a40dc39edb76f94d767565f.png";